var webooker_acivity_models = webooker_acivity_models || {};

(function (ns) {

    // #region ScheduleResourceBase - Ctor
    ns.ScheduleResourceBase = function ScheduleResourceBase() {
        this.singlePeriodProgramOnly = false;

    };
    // #endregion

    // #region ScheduleResourceBase - Methods
    ns.ScheduleResourceBase.prototype.initialize = function (selectedSchedules) {
        this.schedules = [];
        this.selectedSchedules = selectedSchedules;
    }

    ns.ScheduleResourceBase.prototype.getSchedulesByDayImpl = function (sch, dayOfWeek) {
        var all = [];

        if (sch) {
            for (var s = 0; s < sch.length; s++) {
                var schedule = sch[s];
                var dateIndicia = schedule.firstPeriodStartDate ||
                                  schedule.firstPeriodEndDate ||
                                  schedule.secondPeriodStartDate ||
                                  schedule.secondPeriodEndDate;

                if (!!dateIndicia) {
                    var scheduleDayOfWeek = moment(dateIndicia).isoWeekday();

                    if (scheduleDayOfWeek === dayOfWeek) {
                        all.push(schedule);
                    }
                }
            }
        }

        return all;
    };

    ns.ScheduleResourceBase.prototype.getSchedulesByDay = function (sch, dayOfWeek) {
        return this.getSchedulesByDayImpl(sch, dayOfWeek);
    }

    ns.ScheduleResourceBase.prototype.timeCompare = function (vr, s, propertyName) {
        if (typeof vr === "undefined") {
            return s[propertyName];
        } else {
            if (s[propertyName] && vr) {
                var p1 = moment(s[propertyName]);
                var p2 = moment(vr);

                if (p1.hour() !== p2.hour() ||
                    p1.minute() !== p2.minute()) {
                    return "indeterminate";
                } else {
                    return vr;
                }
            } else {
                return vr;
            }
        }
    }

    ns.ScheduleResourceBase.prototype.getScheduleIndiciesByDay = function (dayOfWeek) {
        var sch = this.getSchedulesByDay(this.schedules, dayOfWeek);
        var selectedSch = this.getSchedulesByDay(this.selectedSchedules, dayOfWeek);

        if (sch.length === 0) {
            return '';
        }

        if (sch.length !== selectedSch.length) {
            return "indeterminate";
        }

        var fpsd, spsd;

        angular.forEach(sch, function (s, idx) {
            fpsd = this.timeCompare(fpsd, s, 'firstPeriodStartDate');
            spsd = this.timeCompare(spsd, s, 'secondPeriodStartDate');
        }, this);

        if (fpsd && fpsd === "indeterminate") {
            return "indeterminate";
        }

        if (spsd && spsd === "indeterminate") {
            return "indeterminate";
        }

        if (fpsd && spsd) { return 'both'; }
        if (fpsd && this.singlePeriodProgramOnly) { return 'both'; }
        if (fpsd) { return 'am'; }
        if (spsd) { return 'pm'; }

        return '';
    }
    // #endregion

    // #region ScheduleResourceBase - Properties

    Object.defineProperty(ns.ScheduleResourceBase.prototype, 'monday', {
        enumerable: true, configurable: true,
        get: function () {
            return this.getScheduleIndiciesByDay(1);
        }
    });

    Object.defineProperty(ns.ScheduleResourceBase.prototype, 'tuesday', {
        enumerable: true, configurable: true,
        get: function () { return this.getScheduleIndiciesByDay(2); }
    });

    Object.defineProperty(ns.ScheduleResourceBase.prototype, 'wednesday', {
        enumerable: true, configurable: true,
        get: function () { return this.getScheduleIndiciesByDay(3); }
    });

    Object.defineProperty(ns.ScheduleResourceBase.prototype, 'thursday', {
        enumerable: true, configurable: true,
        get: function () { return this.getScheduleIndiciesByDay(4); }
    });

    Object.defineProperty(ns.ScheduleResourceBase.prototype, 'friday', {
        enumerable: true, configurable: true,
        get: function () { return this.getScheduleIndiciesByDay(5); }
    });

    Object.defineProperty(ns.ScheduleResourceBase.prototype, 'saturday', {
        enumerable: true, configurable: true,
        get: function () { return this.getScheduleIndiciesByDay(6); }
    });

    Object.defineProperty(ns.ScheduleResourceBase.prototype, 'sunday', {
        enumerable: true, configurable: true,
        get: function () { return this.getScheduleIndiciesByDay(7); }
    });

    Object.defineProperty(ns.ScheduleResourceBase.prototype, 'notes', {
        enumerable: true, configurable: true,
        get: function () {

            var days = new Array(7);

            if (this.schedules) {
                for (var s = 0; s < this.schedules.length; s++) {
                    var schedule = this.schedules[s];
                    var dateIndicia = schedule.firstPeriodStartDate ||
                                      schedule.firstPeriodEndDate ||
                                      schedule.secondPeriodStartDate ||
                                      schedule.secondPeriodEndDate;

                    if (!!dateIndicia) {
                        days[moment(dateIndicia).isoWeekday() - 1] = schedule;
                    }
                }
            }

            var result = '';

            for (var d = 0; d < days.length; d++) {
                var day = days[d];
                if (day && !String.prototype.isNullOrWhitespace(day.notes)) {
                    if (String.prototype.isNullOrWhitespace(result)) {
                        result += '{' + d + '}: ' + day.notes;
                    } else {
                        result += ', {' + d + '}: ' + day.notes;
                    }
                }
            }

            return result;
        }
    });

    // #endregion


})(webooker_acivity_models);